import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { StoreContext } from "../../../store/Provider";
import { basename } from "../../../config"
import "./modal.css";

const BlueSwitch = withStyles({
  switchBase: {
    color: "#a3acc3",
    "&$checked": {
      color: "#122d76"
    },
    "&$checked + $track": {
      backgroundColor: "#122d76"
    }
  },
  checked: {},
  track: {
    backgroundColor: "#a3acc3"
  }
})(Switch);

function RequestQuote(props) {
  const context = useContext(StoreContext);
  const [state, setState] = useState({
    pickContainer: false,
    oversizedCargo: false,
    dangerousCargo: false
  });
  const [line, setLine] = useState({});
  const [shpType, setShpType] = useState("FCL");
  const [inputValue, setInputValue] = useState({
    weight: "",
    commodity: "",
    quantity: "",
    valueAddedServices: ""
  });
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [open, setOpen] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  useEffect(() => {
    setLine(props.data);
  }, [props]);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const resetFilters = () => {
    setState({
      pickContainer: false,
      oversizedCargo: false,
      dangerousCargo: false
    });
    setShpType("FCL");
    setInputValue({
      weight: "",
      commodity: "",
      quantity: "",
      valueAddedServices: ""
    });
  };

  const handleChangeInput = (e) => {
    setInputValue({ ...inputValue, [e.target.name]: e.target.value });
  };

  const handleShpType = (e) => {
    setShpType(e.target.value);
  };

  const requestQuote = () => {
    let body = `Hello, %0A%0ATeam My MTS, %0A%0AKindly accept the request for following shipments:- %0A%0A    %E2%80%A2 Origin Country : ${context.requestQuote.origincountry}%0A    %E2%80%A2 Origin Port : ${context.requestQuote.OriginPort}%0A    %E2%80%A2 Destination Country : ${context.requestQuote.destinationCountry}%0A    %E2%80%A2 Destination Port : ${context.requestQuote.destinationPort}%0A    %E2%80%A2 Availvable Direction :  ${context.requestQuote.availvableDirection}%0A    %E2%80%A2 Date to Ship : ${context.requestQuote.dateShip}%0A    %E2%80%A2 Week Ahead :   ${context.requestQuote.weekAhead} weeks%0A%0ASelected schedule for shipments :- %0A%0A    %E2%80%A2 Shipment Type : ${shpType}%0A    %E2%80%A2 Commodity : ${inputValue.commodity}%0A    %E2%80%A2 Weight: ${inputValue.weight}kg%0A    %E2%80%A2 Quantity/Volume : ${inputValue.quantity}m%C2%B3%0A    %E2%80%A2 Oversized Cargo : ${state.oversizedCargo}%0A    %E2%80%A2 Dangerous Cargo  : ${state.dangerousCargo}%0A    %E2%80%A2 Pick empty Container : ${state.pickContainer}%0A%0AThanks.`;
    if (!inputValue.weight) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill Weight!");
    } else if (!/^\d+$/.test(inputValue.weight)) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct Weight!");
    } else if (!inputValue.commodity) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill Commodity!");
    } else if (!inputValue.quantity) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill Quantity/Volume!");
    } else if (!/^\d+$/.test(inputValue.quantity)) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct Quantity/Volume!");
    } else {
      window.location.href = `mailto:importops@mtsnyc.com?subject=Shipment request.&body=${body}`;
      // setOpenalert(true);
      // setSeverity("success");
      // setAlertText("All fields are filled!");
      context.handleModalClose();
    }
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  if (line.data) {
    let date = new Date(0);
    date.setUTCSeconds(line.data.cutOff);
    const cutoffdate = moment(date).format("MM/DD/YYYY");
    return (
      <div className="RequestQuoteComponent">
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={openalert}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert severity={severity} onClose={handleClose}>
            {alertText}
          </Alert>
        </Snackbar>
        <div className="modalHeading">
          <h6>Request Quote</h6>
          <CloseIcon className="pointer" onClick={context.handleModalClose} />
        </div>
        <div className="filterModalBody">
          <div className="scheduleSearchcardbody my-2">
            <div className="scheduleSearchcardbodyCommon mb-2 pb-2">
              <div className="scheduleSearchcardbodyInner">
                <div className="scheduleSearchcardInner compdetails ps-0">
                  <img src={line.logo ?? line.logo} alt="company logo" />
                  <span>{line.compName ?? line.compName}</span>
                </div>
                <div className="scheduleSearchcardInner commondetails">
                  <span>TRANSIT DAYS</span>
                  <p>{line.data.transitTime} Days</p>
                </div>
                <div className="scheduleSearchcardInner commondetails">
                  <span>ETA</span>
                  <p>{cutoffdate}</p>
                </div>
                <div className="scheduleSearchcardInner requestQuote"></div>
              </div>
            </div>
            <div className="scheduleSearchcardbodyItterarte">
              {line.data.transShipments.map((transShipments) => {
                let etdDate = new Date(0);
                etdDate.setUTCSeconds(transShipments.departure.date);
                const etd = moment(etdDate).format("MM/DD/YYYY");
                let etaDate = new Date(0);
                etaDate.setUTCSeconds(transShipments.arrival.date);
                const eta = moment(etaDate).format("MM/DD/YYYY");
                return (
                  <div className="scheduleSearchcardbodyInner">
                    <div className="scheduleSearchcardInner commondetails ps-0">
                      <span>Vessel</span>
                      <p title={transShipments.vesselName}>
                        {!transShipments.vesselName &&
                          transShipments.vesselName === null
                          ? "N/A"
                          : transShipments.vesselName}
                      </p>
                    </div>
                    <div className="scheduleSearchcardInner commondetails">
                      <span>Service</span>
                      <p title={transShipments.service}>
                        {!transShipments.service &&
                          transShipments.service === null
                          ? "N/A"
                          : transShipments.service}
                      </p>
                    </div>
                    <div className="scheduleSearchcardInner commondetails">
                      <span>ETD</span>
                      <p>{!etd && etd !== null ? "N/A" : etd}</p>
                    </div>
                    <div className="scheduleSearchcardInner commondetails">
                      <span>ETA</span>
                      <p>{!eta && eta !== null ? "N/A" : eta}</p>
                    </div>
                    <div className="scheduleSearchcardInner milecol">
                      <div className="searchshptimelineBody">
                        <span>ORIGIN</span>
                        <div className="searchshptimelinecontainer">
                          <span>
                            <img
                              src={`/${basename}/Assets/Images/PlaceDot.svg`}
                              alt="placeDot"
                            />
                          </span>
                          <span>
                            <img
                              src={`/${basename}/Assets/Images/PlaceDot.svg`}
                              alt="placeDot"
                            />
                          </span>
                          <img
                            className="dottedline"
                            src={`/${basename}/Assets/Images/Line.svg`}
                            alt="line"
                          />
                        </div>
                        <span>DESTINATION</span>
                      </div>
                      <p>
                        <span title={transShipments.departure.portName}>
                          {transShipments.departure.portName}
                        </span>
                        <span title={transShipments.arrival.portName}>
                          {transShipments.arrival.portName}
                        </span>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="reqQuoteFilters">
            <div className="reqQuoteFiltersInnerF">
              <div className="reqQuoteFiltersRow">
                <label className="form-label">Shipment Type*</label>
                <select
                  className="form-select"
                  value={shpType}
                  onChange={handleShpType}
                >
                  <option value="FCL">FCL</option>
                  <option value="LCL">LCL</option>
                  <option value="LSE">LSE</option>
                </select>
              </div>
              <div className="reqQuoteFiltersRow">
                <label className="form-label">Weight* (kg)</label>
                <input
                  type="text"
                  className="form-control"
                  name="weight"
                  value={inputValue.weight}
                  placeholder="Weight"
                  onChange={handleChangeInput}
                />
              </div>
            </div>
            <div className="reqQuoteFiltersInner">
              <div className="reqQuoteFiltersRow">
                <label className="form-label">Commodity*</label>
                <input
                  type="text"
                  className="form-control"
                  name="commodity"
                  value={inputValue.commodity}
                  placeholder="Commodity"
                  onChange={handleChangeInput}
                />
              </div>
              <div className="reqQuoteFiltersRow">
                <label className="form-label">
                  Quantity/Volume* (m<sup>3</sup>)
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="quantity"
                  value={inputValue.quantity}
                  placeholder="Quantity/Volume"
                  onChange={handleChangeInput}
                />
              </div>
            </div>
            <div className="reqQuoteFiltersInnerL">
              <div className="reqQuoteFiltersRow">
                <FormControlLabel
                  control={
                    <BlueSwitch
                      checked={state.pickContainer}
                      onChange={handleChange}
                      name="pickContainer"
                    />
                  }
                  label="Pick up the empty container(s) in aother city"
                />
              </div>
              <div className="reqQuoteFiltersRow">
                <FormControlLabel
                  control={
                    <BlueSwitch
                      checked={state.oversizedCargo}
                      onChange={handleChange}
                      name="oversizedCargo"
                    />
                  }
                  label="Oversized Cargo"
                />
              </div>
              <div className="reqQuoteFiltersRow">
                <FormControlLabel
                  control={
                    <BlueSwitch
                      checked={state.dangerousCargo}
                      onChange={handleChange}
                      name="dangerousCargo"
                    />
                  }
                  label="Dangerous Cargo"
                />
              </div>
            </div>
          </div>
          <div className="reqQuoteFiltersRow reqQuoteFiltersLastRow">
            <label className="form-label">Value added services</label>
            <input
              type="text"
              className="form-control"
              name="valueAddedServices"
              value={inputValue.valueAddedServices}
              placeholder="Value added services"
              onChange={handleChangeInput}
            />
          </div>
        </div>
        <div className="modalFooter pt-3 pb-2">
          <Button variant="contained" onClick={resetFilters}>
            Reset
          </Button>
          <Button variant="contained" onClick={requestQuote}>
            Request Quote
          </Button>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default RequestQuote;
